import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import ProfilePageContainer, {
  profileUrl as getProfileUrl,
} from "components/ProfilePageLayout";
import ProfilePageTeam from "components/ProfilePageLayout/ProfilePageTeam";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";

const ProfileTeamPage: NextPageWithLayout = ({}: any) => {
  return <ProfilePageTeam />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const profileUrl = getProfileUrl(slug, true);
    const profile = await baseFetcher(profileUrl, context);

    if (!profile || profile.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        profile,
        fallback: {
          [profileUrl]: profile,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps company team Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

ProfileTeamPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <ProfilePageContainer {...pageProps}>{page}</ProfilePageContainer>
    </SWRConfig>
  );
};

export default ProfileTeamPage;
